import { config } from '@/utils/config'

export default {
  data: function() {
    return {
      config: config,
      plates: config.platesData,
      publicPath: config.publicPath
    }
  },
  methods: {
    getParam: function(name){
      const url = window.location.href
      name = name.replace(/[\[\]]/g, "\\$&")  // eslint-disable-line
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    },
    changeView: function({viewName, answerName='', answerIndex=0, plateNumber=0, transitionName='right'} = {}) {
      this.$emit('change-view', {viewName, answerName, answerIndex, plateNumber, transitionName})
    },
    answerImagePath: function(plate) {
      return `${config.publicPath}/images/answer/${plate}.svg`
    },
    currentPlates: function() {
      let plates = []
      if (this.plateNumber < 0) {
        plates = this.getCustomPlateList()
      } else {
        plates = config.platesData[this.plateNumber]
      }
      return plates
    },
    plateIndex: function() {
      let plates = this.currentPlates()
      return plates.indexOf(this.answerName)
    },
    customClassName: function(index) {
      const pos = index + 1
      return `pos${pos}`
    },
    validCustomPlayte(plate) {
      if (!plate) {
        plate = ''
      }
      return plate.match(/(.){0,5}/ug)[0]
    },
    getCustomPlate: function() {
      let plate = this.$localStorage.get('customPlate')
      return this.validCustomPlayte(plate)
    },
    getCustomPlateList: function() {
      let plate = this.getCustomPlate()
      let plates = plate.match(/./ug)
      if (!plates) {
        return []
      }
      return plates
    },
    setCustomPlate: function(plate) {
      this.$localStorage.set('customPlate', this.validCustomPlayte(plate))
    }
  }
}